/* BreakingT — Labor Day Weekend Sale takeover
   Countdown, copy-to-clipboard, PDP "price with code" sync, cart checkout
   auto-apply, and client-side auto-expiry. Config comes from window.BT_LDW
   (set in layout/theme.liquid). Safe to load on every page; no-ops when
   the sale is off. */
(function () {
  'use strict';

  var cfg = window.BT_LDW || {};
  if (!cfg.enabled || !cfg.code) return;

  var percent = Number(cfg.percent) || 15;
  var endMs = Number(cfg.endMs) || 0;
  var code = String(cfg.code);
  var discountCheckoutUrl = '/discount/' + encodeURIComponent(code) + '?redirect=%2Fcheckout';
  var expired = false;

  /* ---------- helpers ---------- */
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function formatMoney(cents) {
    var fmt = typeof moneyFormat === 'string' ? moneyFormat : (cfg.moneyFormat || '');
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && fmt) {
      try { return Shopify.formatMoney(cents, fmt); } catch (e) { /* fall through */ }
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function priceWithCode(cents) {
    // Round half-up to the cent, matching Shopify discount rounding.
    return Math.round(cents * (100 - percent) / 100);
  }

  /* ---------- auto-expiry ---------- */
  function expire() {
    if (expired) return;
    expired = true;
    $all('[data-bt-ldw]').forEach(function (el) { el.hidden = true; });
    document.documentElement.classList.add('bt-ldw-expired');
  }

  function isActive() {
    return !expired && (!endMs || Date.now() < endMs);
  }

  /* ---------- countdown ---------- */
  function renderTimers() {
    if (!endMs) return;
    var diff = endMs - Date.now();
    if (diff <= 0) { expire(); return; }
    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    $all('[data-bt-ldw-timer]').forEach(function (t) {
      var dd = t.querySelector('[data-ldw-d]');
      var hh = t.querySelector('[data-ldw-h]');
      var mm = t.querySelector('[data-ldw-m]');
      var ss = t.querySelector('[data-ldw-s]');
      var dWrap = t.querySelector('[data-ldw-d-unit]');
      if (dd) dd.textContent = String(d);
      if (hh) hh.textContent = pad(h);
      if (mm) mm.textContent = pad(m);
      if (ss) ss.textContent = pad(s);
      if (dWrap) dWrap.hidden = d === 0;
      t.setAttribute('data-bt-ldw-ready', '1');
    });
  }

  /* ---------- copy code ---------- */
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.top = '-1000px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy') ? resolve() : reject(); } catch (e) { reject(e); }
      document.body.removeChild(ta);
    });
  }

  function onCopyClick(btn) {
    var value = btn.getAttribute('data-code') || code;
    var live = btn.querySelector('[data-bt-ldw-live]');
    copyText(value).then(function () {
      btn.classList.add('is-copied');
      if (live) live.textContent = 'Code ' + value + ' copied to clipboard';
      setTimeout(function () {
        btn.classList.remove('is-copied');
        if (live) live.textContent = '';
      }, 2200);
    }).catch(function () {
      // Clipboard blocked — select the text so the shopper can copy manually.
      var val = btn.querySelector('.bt-ldw-code__value');
      if (val && window.getSelection) {
        var range = document.createRange();
        range.selectNodeContents(val);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      }
    });
  }

  /* ---------- PDP price sync on variant change ---------- */
  function updatePdpPrice(sectionId, variant) {
    if (!variant || typeof variant.price !== 'number') return;
    var nodes = $all('[data-bt-ldw-pdp]');
    nodes.forEach(function (node) {
      if (sectionId && node.getAttribute('data-section-id') && node.getAttribute('data-section-id') !== sectionId) return;
      var value = node.querySelector('[data-bt-ldw-price-value]');
      var reg = node.querySelector('[data-bt-ldw-price-reg]');
      if (value) value.textContent = formatMoney(priceWithCode(variant.price));
      if (reg) reg.textContent = formatMoney(variant.price);
    });
  }

  function bindVariantChange() {
    // subscribe/PUB_SUB_EVENTS are top-level bindings in common.js (not window props).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data ? event.data : event;
        if (!data) return;
        updatePdpPrice(data.sectionId, data.variant);
      });
    }
  }

  /* ---------- checkout auto-apply (cart page form button) ---------- */
  function bindCheckoutIntercept() {
    if (!cfg.autoApply) return;
    document.addEventListener('click', function (event) {
      var btn = event.target.closest('#cartCheckout');
      if (!btn || !isActive()) return;
      var form = btn.form || document.getElementById('cart');
      if (form && typeof form.checkValidity === 'function' && !form.checkValidity()) return;
      event.preventDefault();
      window.location.href = discountCheckoutUrl;
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (event) {
    var copyBtn = event.target.closest('[data-bt-ldw-copy]');
    if (copyBtn) {
      event.preventDefault();
      onCopyClick(copyBtn);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var copyBtn = event.target.closest && event.target.closest('[data-bt-ldw-copy]');
    if (copyBtn && copyBtn.tagName !== 'BUTTON') {
      event.preventDefault();
      onCopyClick(copyBtn);
    }
  });

  /* ---------- init ---------- */
  function init() {
    if (endMs && Date.now() >= endMs) { expire(); return; }
    renderTimers();
    setInterval(renderTimers, 1000);
    bindVariantChange();
    bindCheckoutIntercept();
    // Re-render timers when the cart drawer is (re)loaded or a section is loaded in the editor.
    document.addEventListener('shopify:section:load', renderTimers);
    var observer = new MutationObserver(function () { renderTimers(); });
    var drawerBody = document.querySelector('[data-drawer-body]');
    if (drawerBody) observer.observe(drawerBody, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
